/**
 * EuroIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const EuroIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.922 21.203q-2.967 0-5.289-1.648-2.32-1.65-3.288-4.352H3.97q-.48 0-.808-.33-.33-.33-.33-.807 0-.48.33-.809a1.1 1.1 0 0 1 .808-.329h1.9a6.6 6.6 0 0 1-.056-1.02q.012-.485.057-.836h-1.9q-.48 0-.81-.33a1.1 1.1 0 0 1-.328-.808q0-.478.329-.808.33-.33.808-.33h2.375a9.2 9.2 0 0 1 3.297-4.324q2.313-1.675 5.28-1.675 1.498 0 2.84.443a9.5 9.5 0 0 1 2.504 1.26.94.94 0 0 1 .414.744.95.95 0 0 1-.314.786 1.18 1.18 0 0 1-.824.357 1.53 1.53 0 0 1-.886-.24 6.95 6.95 0 0 0-3.734-1.075q-2.01 0-3.63 1.043Q9.676 7.16 8.86 8.797h5.11q.48 0 .808.329.33.33.33.808 0 .48-.33.808-.33.33-.808.33H8.165a6 6 0 0 0 0 1.856h5.805q.48 0 .808.33.33.33.33.808t-.33.808-.808.33H8.83a6.64 6.64 0 0 0 2.46 2.704q1.62 1.02 3.632 1.02 1.025 0 1.97-.29a7.3 7.3 0 0 0 1.765-.81q.404-.256.885-.228.482.028.824.37a.94.94 0 0 1 .314.783.94.94 0 0 1-.414.74 9.4 9.4 0 0 1-2.503 1.267 9 9 0 0 1-2.84.443" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const EuroIcon = makeIcon('EuroIcon', EuroIconSvg)
